/* Kerstgeluk: zet het ontwerp van elke gepersonaliseerde kerstbal ook op de bestelling zelf
   (winkelwagenkenmerken "Kerstbal 1", "Kerstbal 1 ontwerp", "Kerstbal 1 afbeelding", ...). In het beheer staat het
   bij de bestelling onder Aanvullende gegevens, met links naar het ontwerp (snijbestand) en de geuploade afbeelding.
   Het ontwerp-bestand heet op de bestelregel "Ontwerp" (zichtbaar voor de klant); het soort ontwerp heet "Soort ontwerp".
   Wordt opnieuw opgebouwd bij elke wijziging van het winkelmandje. Geen externe afhankelijkheden. */
(function(){
  if(window.kgCartSync)return;
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||"/";
  var SKIP={"_kg":1,"_ontwerpcode":1,"_Snijbestand":1,"_Snijmaat":1,"Ontwerp":1,"Jouw afbeelding":1,"Formaat":1};
  var busy=null,again=false;
  function line(it){
    var p=it.properties||{},s=[],k;
    s.push((it.variant_title||it.product_title||"Kerstbal").split(" / ").join(", ")+(p["Formaat"]?", "+p["Formaat"]:""));
    if(it.quantity>1)s.push("Aantal: "+it.quantity);
    for(k in p){if(SKIP[k]||k.charAt(0)==="_"||p[k]==null||p[k]==="")continue;s.push(k+": "+p[k]);}
    if(p["_Snijmaat"])s.push("Snijmaat: "+p["_Snijmaat"]);
    return s.join(" | ");
  }
  /* Shopify geeft geuploade afbeeldingen aan browsers als WebP. Daarom wijzen de links naar /pages/ontwerp: die haalt het
     origineel (PNG of JPG) op, zet bij het ontwerp de 300 dpi terug en downloadt met een herkenbare naam. */
  function slug(t){return String(t||"").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g,"").replace(/[^a-z0-9]+/g,"-").replace(/^-+|-+$/g,"").slice(0,24);}
  function link(url,name,dpi){var m=/\/s\/files\/(.+)$/.exec(url||"");if(!m)return url;return location.origin+"/pages/ontwerp?f="+m[1]+"&n="+encodeURIComponent(name)+(dpi?"&d="+dpi:"");}
  function baseName(it,n){var p=it.properties||{},t=p["Regel 1"]&&p["Regel 1"]!=="(leeg)"?p["Regel 1"]:(p["Collega"]||p["Soort ontwerp"]||"");
    return ["kerstbal",n,slug(t),slug((it.variant_title||"").split(" / ")[0])].filter(Boolean).join("-");}
  function run(){
    return fetch(root+"cart.js",{headers:{"Accept":"application/json"},credentials:"same-origin"}).then(function(r){return r.json();}).then(function(c){
      var want={},n=0,old=c.attributes||{},upd={},changed=false,k;
      (c.items||[]).forEach(function(it){var p=it.properties,b,f,nm,mm;if(p&&p._kg){n++;b="Kerstbal "+n;want[b]=line(it);nm=baseName(it,n);mm=/(\d+)\s*x\s*(\d+)/.exec(p["_Snijmaat"]||"");
        f=p["Ontwerp"]||p["_Snijbestand"];if(f&&/^https?:/.test(f))want[b+" ontwerp"]=link(f,nm+(mm?"-"+mm[1]+"x"+mm[2]+"mm":""),300);
        if(p["Jouw afbeelding"])want[b+" afbeelding"]=link(p["Jouw afbeelding"],nm+"-afbeelding");}});
      for(k in want)if(old[k]!==want[k]){upd[k]=want[k];changed=true;}
      for(k in old)if(/^(Kerst)?[Bb]al \d+( ontwerp| afbeelding| snijbestand| afbeelding klant)?$/.test(k)&&!(k in want)&&old[k]!==""){upd[k]="";changed=true;}
      if(!changed)return c;
      return fetch(root+"cart/update.js",{method:"POST",credentials:"same-origin",headers:{"Content-Type":"application/json","Accept":"application/json","X-KG-Sync":"1"},body:JSON.stringify({attributes:upd})}).then(function(r){return r.json();});
    });
  }
  function sync(){
    if(busy){again=true;return busy;}
    busy=run().catch(function(){}).then(function(r){busy=null;if(again){again=false;return sync();}return r;});
    return busy;
  }
  window.kgCartSync=sync;
  /* Niet tegelijk met andere winkelmandacties schrijven: wachten tot het stil is, en tot de configurator klaar is (kgCartBusy). */
  var tm=null;
  function schedule(){clearTimeout(tm);tm=setTimeout(function(){if(window.kgCartBusy){schedule();return;}sync();},400);}
  /* Vult de bestelregel van de configurator aan voordat hij naar het winkelmandje gaat:
     het veld Ontwerp volgt wat er echt op de bal staat, en de snijmaat komt uit de bestandsnaam van het snijbestand. */
  function fixForm(fd){
    try{
      /* Alleen nodig voor de oude versie van de configurator (met _Snijbestand). */
      if(!(fd instanceof FormData)||!fd.has("properties[_kg]")||!fd.has("properties[_Snijbestand]"))return;
      var a=String(fd.get("properties[Afbeelding]")||""),o=fd.get("properties[Ontwerp]");
      if(typeof o!=="string")o=null;
      if(/^Eigen afbeelding/.test(a))o="Eigen tekening";else if(/^Silhouet van foto/.test(a))o="Foto als silhouet";else if(/^Logo/.test(a))o="Logo";
      fd.delete("properties[Ontwerp]");
      if(o)fd.set("properties[Soort ontwerp]",o);
      var f=fd.get("properties[_Snijbestand]"),m=f&&f.name&&/_(\d+)x(\d+)mm\.png$/i.exec(f.name);
      if(m)fd.set("properties[_Snijmaat]",m[1]+" x "+m[2]+" mm");
      if(f&&typeof f!=="string"){fd.delete("properties[_Snijbestand]");fd.append("properties[Ontwerp]",f,f.name);}
    }catch(e){}
  }
  var of=window.fetch;
  if(of){
    window.fetch=function(input,init){
      var url=typeof input==="string"?input:(input&&input.url)||String(input||""),h=init&&init.headers,mine=false;
      try{mine=!!(h&&(h["X-KG-Sync"]||(h.get&&h.get("X-KG-Sync"))));}catch(e){}
      if(!mine&&/\/cart\/add(\.js)?(\?|$)/.test(url)&&init&&init.body)fixForm(init.body);
      var pr=of.apply(this,arguments);
      if(!mine&&/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url))pr.then(schedule,function(){});
      return pr;
    };
  }
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",sync);else sync();
  window.addEventListener("pageshow",function(e){if(e.persisted)sync();});
})();
